import { defineMessages } from 'react-intl';

import removeFromCollectionHover from '../../static/icons/actions/ic_remove_circle_filled_24.svg';
import removeFromCollection from '../../static/icons/backstage/ic_check_circle_filled_24.svg';
import more from '../../static/icons/backstage/ic_more_circle_24.svg';
import play from '../../static/icons/backstage/ic_play_circle_48.svg';
import addToCollection from '../../static/icons/ic_add_circle_24.svg';
import share from '../../static/icons/ic_share_circle_24.svg';
import shuffle from '../../static/icons/ic_shuffle_circle_24.svg';

export const ButtonRowButtonSize = Object.freeze({
  play: 'large',
  pause: 'large',
  playStation: 'large',
} as const);

export const ButtonRowType = Object.freeze({
  ADD_TO_COLLECTION: 'addToCollection',
  CREATE_STATION: 'createStation',
  DELETE_PLAYLIST: 'deletePlaylist',
  DELETE_STATION: 'deleteStation',
  EDIT: 'edit',
  MORE: 'more',
  PAUSE: 'pause',
  PLAY: 'play',
  REMOVE_FROM_COLLECTION: 'removeFromCollection',
  SHARE: 'share',
  SHUFFLE: 'shuffle',
} as const);

export const ButtonTextType = Object.freeze({
  PAUSE: 'pause',
  PAUSE_ALBUM: 'pauseAlbum',
  PAUSE_EPISODE: 'pauseEpisode',
  PAUSE_PODCAST: 'pausePodcast',
  PAUSE_SONG: 'pauseSong',
  PLAY: 'play',
  PLAY_ALBUM: 'playAlbum',
  PLAY_EPISODE: 'playEpisode',
  PLAY_PLAYLIST: 'playPlaylist',
  PLAY_PODCAST: 'playPodcast',
  PLAY_SONG: 'playSong',
  PLAY_STATION: 'playStation',
  PLAY_TOP_SONGS: 'playTopSongs',
  PLAY_TOP_SONGS_WITH_NAME: 'playTopSongsWithName',
  PLAY_WITH_NAME: 'playWithName',
} as const);

export const ButtonRowIcons = Object.freeze({
  addToCollection: { default: addToCollection },
  deletePlaylist: {
    default: removeFromCollection,
    hover: removeFromCollectionHover,
  },
  deleteStation: {
    default: removeFromCollection,
    hover: removeFromCollectionHover,
  },
  more: { default: more },
  play: { default: play },
  removeFromCollection: {
    default: removeFromCollection,
    hover: removeFromCollectionHover,
  },
  share: { default: share },
  shuffle: { default: shuffle },
} as const);

export const ButtonRowText = defineMessages({
  addToCollection: { id: 't.addToCollection', defaultMessage: 'Collect' },
  deletePlaylist: { id: 't.deletePlaylist', defaultMessage: 'Delete Playlist' },
  deleteStation: { id: 't.deleteStation', defaultMessage: 'Delete Station' },
  edit: { id: 't.edit', defaultMessage: 'Edit' },
  more: { id: 't.more', defaultMessage: 'More' },
  pause: { id: 't.pause', defaultMessage: 'Pause' },
  pauseAlbum: { id: 't.pauseAlbum', defaultMessage: 'Pause Album' },
  pauseEpisode: { id: 't.pauseEpisode', defaultMessage: 'Pause Episode' },
  pausePodcast: { id: 't.pausePodcast', defaultMessage: 'Pause Podcast' },
  pauseSong: { id: 't.pauseSong', defaultMessage: 'Pause Song' },
  play: { id: 't.play', defaultMessage: 'Play' },
  playAlbum: { id: 't.playAlbum', defaultMessage: 'Play Album' },
  playPlaylist: { id: 't.playPlaylist', defaultMessage: 'Play Playlist' },
  playPodcast: { id: 't.playPodcast', defaultMessage: 'Play Podcast' },
  playSong: { id: 't.playSong', defaultMessage: 'Play Song' },
  playStation: { id: 't.playStation', defaultMessage: 'Start Station' },
  playTopSongs: { id: 't.playTopSongs', defaultMessage: 'Play Top Songs' },
  playTopSongsWithName: {
    id: 't.playTopSongsWithName',
    defaultMessage: 'Play Top {name} Songs',
  },
  playWithName: { id: 't.play', defaultMessage: 'Play {name}' },
  removeFromCollection: {
    id: 't.removeFromCollection',
    defaultMessage: 'Remove from your collection',
  },
  share: { id: 't.share', defaultMessage: 'Share' },
  shuffle: { id: 't.shuffle', defaultMessage: 'Shuffle' },
} as const);
